var E = "kunden-konto-session-id", t = "X-Correlation-ID", o = "X-Session-ID", _ = "rx-token", n = "bearer", a = class extends Error {
  response;
  request;
  constructor(r, e, s = {}) {
    super(`Request failed with status code ${r}`), this.name = "HttpError", this.response = {
      status: r,
      data: e
    }, this.request = s;
  }
};
export {
  E as DEFAULT_SESSION_ID_KEY,
  a as HttpError,
  n as IMPERSONATION_TOKEN_STORAGE_STARTING_VALUE,
  _ as TOKEN_STORAGE_KEY,
  t as X_CORRELATION_ID_HEADER,
  o as X_SESSION_ID_HEADER
};

//# sourceMappingURL=useBffApi.types.js.map